/** @typedef {'live-music' | 'variety'} EntertainmentCategorySlug */

/** Canonical Payload category slugs. */
export const ENTERTAINMENT_CATEGORY_SLUGS = /** @type {const} */ ([
  "live-music",
  "variety",
]);

/**
 * Maps public URL :category segment (EN or FR path) → Payload slug.
 * @type {Record<string, EntertainmentCategorySlug>}
 */
const ROUTE_CATEGORY_TO_SLUG = {
  variety: "variety",
  varietes: "variety",
  "live-music": "live-music",
  "concerts-live": "live-music",
};

/** Legacy ERS labels → slug. */
const LEGACY_CATEGORY_ALIASES = {
  "Live Music": "live-music",
  "Concerts Live": "live-music",
  Variety: "variety",
  Variétés: "variety",
};

/**
 * @param {string | undefined} routeCategory - `params.category` from react-router
 * @returns {EntertainmentCategorySlug | undefined}
 */
export function routeCategoryToSlug(routeCategory) {
  if (!routeCategory) return undefined;
  const trimmed = routeCategory.trim();
  if (
    ENTERTAINMENT_CATEGORY_SLUGS.includes(
      /** @type {EntertainmentCategorySlug} */ (trimmed)
    )
  ) {
    return /** @type {EntertainmentCategorySlug} */ (trimmed);
  }
  return ROUTE_CATEGORY_TO_SLUG[trimmed];
}

/**
 * @param {string | undefined} raw - Slug or legacy translated label
 * @returns {EntertainmentCategorySlug | undefined}
 */
export function normalizeEntertainmentCategory(raw) {
  if (!raw) return undefined;
  const trimmed = raw.trim();
  if (
    ENTERTAINMENT_CATEGORY_SLUGS.includes(
      /** @type {EntertainmentCategorySlug} */ (trimmed)
    )
  ) {
    return /** @type {EntertainmentCategorySlug} */ (trimmed);
  }
  return LEGACY_CATEGORY_ALIASES[trimmed];
}

/**
 * @param {string | undefined} routeCategory
 * @param {string | undefined} cardCategory
 * @returns {boolean}
 */
export function entertainmentCategoryMatchesRoute(routeCategory, cardCategory) {
  const routeSlug = routeCategoryToSlug(routeCategory);
  const cardSlug = normalizeEntertainmentCategory(cardCategory);
  if (!routeSlug) return true;
  if (!cardSlug) return false;
  return routeSlug === cardSlug;
}
